document.addEventListener("DOMContentLoaded", function() {

/****** Product Size/Color Selector ******/  
// Size Options
const sizeOptions = document.querySelectorAll('.size-option');
sizeOptions.forEach(option => {
  option.addEventListener('click', function() {
    const productUrl = this.getAttribute('data-product-url');
    
    if (productUrl) {
      sizeOptions.forEach(opt => {
        opt.classList.remove('selected');
        opt.classList.remove('with-right-border');
      });
      
      this.classList.add('selected');
      
      const prev = this.previousElementSibling;
      if (prev) {
        prev.classList.add('with-right-border');
      }
      
      window.location.href = productUrl;
    }
  });
});

/****** Color Dropdown Toggle ******/
const colorDropdown = document.querySelector('.color-dropdown');
const colorDropdownToggle = document.querySelector('.color-dropdown-toggle');
const colorDropdownMenu = document.querySelector('.color-dropdown-menu');
const mobilePanel = document.querySelector('.color-mobile-panel');
const colorOverlay = document.querySelector('.color-dropdown-overlay');
const productHeader = document.querySelector('.section-header.shopify-section-group-header-group');
const productAnnouncements = document.querySelector('.shopify-section-group-header-group');
const productButtons = document.querySelector('.product-btn-container');

/*console.log('=== Color Selector Debug ===');
console.log('colorDropdown:', colorDropdown);
console.log('colorDropdownToggle:', colorDropdownToggle);
console.log('colorDropdownMenu:', colorDropdownMenu);
console.log('mobilePanel:', mobilePanel);
console.log('colorOverlay:', colorOverlay);*/

if (colorDropdownToggle) {
  //console.log('Color dropdown toggle found - initializing...');
  
  // Function to check if mobile
  function isMobile() {
    return window.innerWidth <= 749;
  }
  
  // Toggle dropdown/panel
  colorDropdownToggle.addEventListener('click', function(e) {
    e.preventDefault();
    e.stopPropagation();
    
   /*console.log('=== Click Event ===');
    console.log('Window width:', window.innerWidth);
    console.log('Is mobile:', isMobile());*/
    
    if (isMobile()) {
      // MOBILE
      //console.log('Mobile mode activated');
      if (mobilePanel && colorOverlay) {
        //console.log('Opening mobile panel...');
        colorOverlay.classList.add('active');
        mobilePanel.classList.add('active');
        document.body.style.overflow = 'hidden';
        
        if (productHeader) {
          productHeader.style.zIndex = '1';
        }

        if (productAnnouncements) {
          productAnnouncements.style.zIndex = '1';
        }

        if (productButtons) {
          productButtons.style.zIndex = '1';
        }
        
        //console.log('Mobile panel classes:', mobilePanel.className);
        //console.log('Overlay classes:', colorOverlay.className);
      } else {
        //console.error('Mobile panel or overlay missing!');
        //console.log('mobilePanel exists:', !!mobilePanel);
        //console.log('colorOverlay exists:', !!colorOverlay);
      }
    } else {
      // DESKTOP
      //console.log('Desktop mode activated');
      if (colorDropdown && colorOverlay) {
        const wasActive = colorDropdown.classList.contains('active');
        //console.log('Was active:', wasActive);
        

        if (wasActive) {
          // Close
          //console.log('Closing dropdown');
          colorDropdown.classList.remove('active');
          colorOverlay.classList.remove('active');
          document.body.style.overflow = '';

          if (productHeader) {
            productHeader.style.zIndex = '111111';
          }

          if (productAnnouncements) {
            productAnnouncements.style.zIndex = '4';
          }

          if (productButtons) {
            productButtons.style.zIndex = '999999';
          }
        } else {
          // Open
          //console.log('Opening dropdown');
          colorDropdown.classList.add('active');

          // Check if dropdown needs scroll gradient
          setTimeout(() => {
            if (colorDropdownMenu) {
              if (colorDropdownMenu.scrollHeight > colorDropdownMenu.clientHeight) {
                colorDropdownMenu.classList.add('has-scroll');
              } else {
                colorDropdownMenu.classList.remove('has-scroll');
              }
            }
          }, 350); // After open animation completes

          colorOverlay.classList.add('active');
          document.body.style.overflow = 'hidden';

          if (productHeader) {
            productHeader.style.zIndex = '1';
          }
          if (productAnnouncements) {
            productAnnouncements.style.zIndex = '1';
          }
          if (productButtons) {
            productButtons.style.zIndex = '1';
          }
        }
        
        /*console.log('Dropdown classes after toggle:', colorDropdown.className);
        console.log('Now active:', colorDropdown.classList.contains('active'));*/
      } else {
        /*console.error('Dropdown or overlay missing!');
        console.log('colorDropdown exists:', !!colorDropdown);
        console.log('colorOverlay exists:', !!colorOverlay);*/
      }
    }
  });
  
  // Close function
  function closeColorPanel() {
    //console.log('Closing color panel/dropdown');
    if (mobilePanel) {
      mobilePanel.classList.remove('active');
    }
    if (colorOverlay) {
      colorOverlay.classList.remove('active');
    }
    if (colorDropdown) {
      colorDropdown.classList.remove('active');
    }
    document.body.style.overflow = '';
    
    if (productHeader) {
      productHeader.style.zIndex = '111111';
    }

    if (productButtons) {
      productButtons.style.zIndex = '999999';
    }

    if (colorDropdownMenu) {
      colorDropdownMenu.classList.remove('has-scroll');
    }
  }
  
  // Close button click
  const closeButton = document.querySelector('.color-panel-close');
  if (closeButton) {
    closeButton.addEventListener('click', function(e) {
      e.preventDefault();
      e.stopPropagation();
      console.log('Close button clicked');
      closeColorPanel();
    });
  }
  
  // Close when clicking outside (desktop only)
  document.addEventListener('click', function(e) {
    if (!isMobile() && colorDropdown) {
      if (!colorDropdown.contains(e.target) && colorDropdown.classList.contains('active')) {
        console.log('Clicked outside, closing');
        closeColorPanel();
      }
    }
  });
  
  // Close when clicking overlay
  if (colorOverlay) {
    colorOverlay.addEventListener('click', function() {
      console.log('Overlay clicked');
      closeColorPanel();
    });
  }
  
  // Handle window resize
  let resizeTimer;
  window.addEventListener('resize', function() {
    clearTimeout(resizeTimer);
    resizeTimer = setTimeout(function() {
      if (!isMobile()) {
        closeColorPanel();
      }
    }, 250);
  });
  
  console.log('Color selector initialized successfully');
} else {
  console.warn('Color dropdown toggle button not found - color selector not initialized');
}

/****** Color Swatch Click ******/
const colorSwatches = document.querySelectorAll('.color-swatch');
colorSwatches.forEach(swatch => {
  swatch.addEventListener('click', function(e) {
    const productUrl = this.getAttribute('data-product-url');
    if (productUrl) {
      e.preventDefault();
      window.location.href = productUrl;
    }
  });
});

console.log('=== Color Selector Initialization Complete ===');
console.log('Size options found:', sizeOptions.length);
console.log('Color swatches found:', colorSwatches.length);

/****** end of Product Size/Color Selector ******/
    
/****** Show/Hide Product Description ******/
    const toggleLink = document.querySelector(".toggle-description");
    const shortDescription = document.querySelector(".short-description");
    const fullDescription = document.querySelector(".full-description");
    const rightSide = document.querySelector('.product__info-wrapper');

    if (toggleLink) {
      toggleLink.addEventListener("click", function(event) {
        event.preventDefault();

        // Toggle visibility of description elements
        if (fullDescription.classList.contains("fade-in")) {
          // Hide full description
          fullDescription.classList.remove("fade-in");
          shortDescription.style.display = "inline";
          toggleLink.textContent = "Read more";
        } else {
          // Show full description with animation
          fullDescription.classList.add("fade-in");
          shortDescription.style.display = "none";
          toggleLink.textContent = "Read less";
        
          setTimeout(() => {
            if (rightSide && window.innerWidth >= 750) {
              const windowHeight = window.innerHeight;
              const rightSideRect = rightSide.getBoundingClientRect();
              const rightSideBottom = rightSideRect.bottom;
              
              if (rightSideBottom > windowHeight + 50) {
                rightSide.classList.add('show-gradient');
              }
            }
          }, 100);

        }
      });
    }
/****** end of Show/Hide Product Description ******/

/****** Product Size ******/  
    /*const sizeOptions = document.querySelectorAll('.size-option');

    sizeOptions.forEach(option => {
      option.addEventListener('click', () => {
        // Remove all selected and helper classes
        sizeOptions.forEach(opt => {
          opt.classList.remove('selected');
          opt.classList.remove('with-right-border');
        });

        // Add selected to clicked one
        option.classList.add('selected');

        // If it has a previous sibling, give it the border helper class
        const prev = option.previousElementSibling;
        if (prev) {
          prev.classList.add('with-right-border');
        }
      });
    });*/
/****** end of Product Size ******/
  
//****** Product Accordion with Smooth Animation ******/  
  const accordions = document.querySelectorAll('.product__accordion.accordion details, .product__accordion_need_to_know');
  
  // Function to update icon state immediately
  function updateIconState(accordion, isOpen) {
    const summary = accordion.tagName === 'DETAILS' ? 
      accordion.querySelector('summary') : 
      accordion.querySelector('#key_need_to_know');
    
    if (!summary) return;
    
    const iconPlus = summary.querySelector('.icon-plus');
    const iconMinus = summary.querySelector('.icon-minus');
    
    if (iconPlus && iconMinus) {
      if (isOpen) {
        // Show minus, hide plus
        iconPlus.style.opacity = '0';
        iconPlus.style.transform = 'rotate(180deg)';
        iconMinus.style.opacity = '1';
        iconMinus.style.transform = 'rotate(0deg)';
      } else {
        // Show plus, hide minus
        iconPlus.style.opacity = '1';
        iconPlus.style.transform = 'rotate(0deg)';
        iconMinus.style.opacity = '0';
        iconMinus.style.transform = 'rotate(180deg)';
      }
    }
  }
  
  // Function to get the actual content height
  function getContentHeight(content) {
    const originalMaxHeight = content.style.maxHeight;
    const originalHeight = content.style.height;
    
    content.style.maxHeight = 'none';
    content.style.height = 'auto';
    
    const height = content.scrollHeight;
    
    content.style.maxHeight = originalMaxHeight;
    content.style.height = originalHeight;
    
    return height;
  }
  
  // Function to close accordion with animation
  function closeAccordion(accordion, content) {
    const isDetails = accordion.tagName === 'DETAILS';
    
    // Update icon immediately
    updateIconState(accordion, false);
    
    // Get current height and set it explicitly
    const currentHeight = content.scrollHeight;
    content.style.height = currentHeight + 'px';
    content.style.maxHeight = 'none';
    
    // Force reflow
    content.offsetHeight;
    
    // Start closing animation
    requestAnimationFrame(() => {
      content.style.height = '0px';
      content.classList.remove('open');
      
      if (isDetails) {
        accordion.querySelector('summary').setAttribute('aria-expanded', 'false');
      }
    });
    
    // Clean up after animation
    setTimeout(() => {
      if (isDetails) {
        accordion.removeAttribute('open');
      }
      content.style.maxHeight = '0px';
      content.style.height = '';
    }, 500);
  }
  
  // Function to open accordion with animation
  function openAccordion(accordion, content) {
    const isDetails = accordion.tagName === 'DETAILS';
    
    // Update icon immediately
    updateIconState(accordion, true);
    
    if (isDetails) {
      accordion.setAttribute('open', '');
      accordion.querySelector('summary').setAttribute('aria-expanded', 'true');
    }
    
    // Get the natural height of the content
    const targetHeight = getContentHeight(content);
    
    // Set starting state
    content.style.height = '0px';
    content.style.maxHeight = 'none';
    content.classList.add('open');
    
    // Force reflow
    content.offsetHeight;
    
    // Start opening animation
    requestAnimationFrame(() => {
      content.style.height = targetHeight + 'px';
    });
    
    // Clean up after animation - but keep the exact height to prevent jerking
    setTimeout(() => {
      // Only set to auto if the height hasn't changed
      const currentHeight = content.scrollHeight;
      if (Math.abs(currentHeight - targetHeight) < 2) {
        // Height is stable, safe to set to auto
        content.style.height = 'auto';
      } else {
        // Height changed, keep the measured height
        content.style.height = currentHeight + 'px';
      }
      content.style.maxHeight = 'none';
    }, 520); // Slightly longer than animation duration
  }
  
  // Initialize accordions
  accordions.forEach((accordion, index) => {
    const isDetails = accordion.tagName === 'DETAILS';
    const summary = isDetails ? accordion.querySelector('summary') : accordion.querySelector('#key_need_to_know');
    const content = accordion.querySelector('.accordion__content');
    
    if (!summary || !content) return;
    
    // Set up accessibility attributes
    summary.setAttribute('role', 'button');
    summary.setAttribute('aria-expanded', 'false');
    
    // Set ID for content if it doesn't exist
    if (!content.id) {
      content.id = `accordion-content-${index}`;
    }
    summary.setAttribute('aria-controls', content.id);
    
    // Initialize all accordions as closed first
    content.style.height = '0px';
    content.style.maxHeight = '0px';
    content.classList.remove('open');
    updateIconState(accordion, false); // Set initial icon state
    
    if (isDetails) {
      accordion.removeAttribute('open');
      summary.setAttribute('aria-expanded', 'false');
    }
    
    // Open first accordion by default after a short delay
    if (index === 0) {
      setTimeout(() => {
        openAccordion(accordion, content);
      }, 100);
    }
    
    // Add click event listener
    summary.addEventListener('click', function(event) {
      event.preventDefault();
      
      const isCurrentlyOpen = content.classList.contains('open');
      
      // Close all accordions first
      accordions.forEach((acc) => {
        const accContent = acc.querySelector('.accordion__content');
        if (accContent && accContent.classList.contains('open')) {
          closeAccordion(acc, accContent);
        }
      });
      
      // If the clicked accordion wasn't open, open it
      if (!isCurrentlyOpen) {
        // Small delay to ensure close animation starts first
        setTimeout(() => {
          openAccordion(accordion, content);
        }, 100);
      }
    });
    
    // Handle window resize to recalculate heights
    let resizeTimeout;
    window.addEventListener('resize', function() {
      clearTimeout(resizeTimeout);
      resizeTimeout = setTimeout(() => {
        if (content.classList.contains('open')) {
          const newHeight = getContentHeight(content);
          content.style.height = newHeight + 'px';
        }
      }, 250);
    });
    
    // Handle dynamic content changes with smoother updates
    const observer = new MutationObserver(() => {
      if (content.classList.contains('open')) {
        // Debounce height updates to prevent jerky animations
        clearTimeout(content._heightUpdateTimeout);
        content._heightUpdateTimeout = setTimeout(() => {
          const newHeight = getContentHeight(content);
          const currentHeight = parseInt(content.style.height) || 0;
          
          // Only update if there's a significant change
          if (Math.abs(newHeight - currentHeight) > 5) {
            content.style.transition = 'height 0.3s ease';
            content.style.height = newHeight + 'px';
            
            // Reset transition after update
            setTimeout(() => {
              content.style.transition = 'height 0.5s cubic-bezier(0.25, 0.46, 0.45, 0.94)';
            }, 300);
          }
        }, 100);
      }
    });
    
    observer.observe(content, {
      childList: true,
      subtree: true,
      characterData: true
    });
  });


/****** end of Product Accordion ******/

function scrollToDiv(elementId) {
    document.getElementById(elementId).scrollIntoView({
        behavior: 'smooth',
        block: 'start'
    });
}

// Add click event to your write-review div
const writeReviewBtn = document.getElementById('write-review');
if (writeReviewBtn) {
    writeReviewBtn.addEventListener('click', function() {
        scrollToDiv('product-reviews');
    });
}

//What Else You Need To Know scroll to target  
/*const trigger = document.getElementById("key_need_to_know");
const target = document.getElementById("product-info-keys");

trigger.addEventListener("click", function() {
  target.scrollIntoView({ behavior: "smooth" });
  preventOtherScrollEvents()
});

function preventOtherScrollEvents() {
  // Create a temporary event listener that prevents default scroll behavior
  function preventScroll(event) {
    event.preventDefault();
    event.stopPropagation();
  }

  // Add the event listener
  window.addEventListener("scroll", preventScroll, { passive: false, capture: true });

  // Automatically remove it after a short duration (adjust if needed)
  setTimeout(() => {
    window.removeEventListener("scroll", preventScroll, { capture: true });
  }, 1000); // 1 second, adjust as needed
}*/
/****** end of Product Accordion ******/  

/****** Product Modal Ingredients ******/  
const modal = document.querySelector('#ProductModal-Ingredients');
const openButton = document.querySelector('#openModalButtonIngredients');
const closeButton = document.querySelector('#ModalClose-Ingredients');
const body = document.querySelector('body');
const pageContent = document.querySelector('.content-for-layout');
const headerContent = document.querySelector('.header-wrapper');
const footerContent = document.querySelector('.footer');
const productMediaGallery = document.querySelector('media-gallery');

const overlay = document.createElement('div');
overlay.classList.add('modal-overlay');
document.body.appendChild(overlay);

if (openButton) {
// Open the modal
openButton.addEventListener('click', function () {
  modal.setAttribute('open', '');
  overlay.classList.add('active');
  productMediaGallery.style.pointerEvents = 'none';
  headerContent.classList.add('blur-effect');
  footerContent.classList.add('blur-effect');
  pageContent.classList.add('blur-effect');
  document.body.style.overflow = 'hidden'; // Prevent background scrolling
  modal.focus(); // Set focus on modal for accessibility
});
}

// Close the modal with animation
function closeModal() {
  if (!modal) return;
  modal.classList.add('closing');
  overlay.classList.remove('active');
  headerContent.classList.remove('blur-effect');
  footerContent.classList.remove('blur-effect');
  pageContent.classList.remove('blur-effect');
  document.body.style.overflow = ''; // Restore background scrolling

  modal.addEventListener(
    'animationend',
    function () {
      modal.classList.remove('closing');
      modal.removeAttribute('open');
      productMediaGallery.style.pointerEvents = '';
    },
    { once: true }
  );
}

// Close modal when clicking the close button
if (closeButton) {
  closeButton.addEventListener('click', closeModal);
}

// Close modal only when clicking outside of it (on the overlay)
overlay.addEventListener('click', function (e) {
  if (e.target === overlay) {
    if (modal) closeModal();
  }
});

// Prevent modal from closing when clicking inside (on modal content)
if (modal) {
  modal.addEventListener('click', function (e) {
    e.stopPropagation();
  });
}
/****** end of Product Modal Ingredients ******/  

const container = document.querySelector(".product__info-container");
if (window.scrollY > 0) {
    container.style.height = "calc(100vh - 29px)";
} else {
    container.style.height = "calc(100vh - 70px)";
}

/****** Alternative Sticky Button Implementation ******/
/*function initStickyButton() {
  const productMediaList = document.querySelector('.product__media-list');
  const btnContainer = document.querySelector('.product-btn-container .section-btn-container');
  const productInfoBtnContainer = document.querySelector(".product__info-wrapper .product-btn-container");
  const relatedProducts = document.querySelector('.related-products');
  const outerAfterpay = document.querySelector('.outer.icon-afterpay');
  const footer = document.querySelector('footer') || document.querySelector('.footer');
  
  if (!productMediaList || !btnContainer || !productInfoBtnContainer) {
    return;
  }
  
  // Track the highest scroll position where related products were visible
  let relatedProductsTopPosition = null;
  
  function handleStickyButton() {
    // Only apply on desktop (min-width: 750px as per your CSS)
    if (window.innerWidth < 750) {
      btnContainer.classList.remove('fixed-at-bottom');
      productInfoBtnContainer.classList.remove('test');
      return;
    }
    
    const scrollTop = window.pageYOffset || document.documentElement.scrollTop;
    const windowHeight = window.innerHeight;
    
    // Get the bottom position of the product media list
    const mediaListRect = productMediaList.getBoundingClientRect();
    const mediaListBottom = mediaListRect.bottom + scrollTop;
    
    // Calculate when user has scrolled past the media list
    const userScrolledPastMedia = scrollTop + windowHeight >= mediaListBottom;
    
    // Check related products positioning
    let relatedProductsVisible = false;
    let userScrolledPastRelatedProducts = false;
    
    if (relatedProducts) {
      const relatedProductsRect = relatedProducts.getBoundingClientRect();
      const relatedProductsTop = relatedProductsRect.top + scrollTop;
      
      // Related products are visible when any part is in viewport
      relatedProductsVisible = relatedProductsRect.top < windowHeight && relatedProductsRect.bottom > 0;
      
      // Track the position when related products first become visible
      if (relatedProductsVisible && relatedProductsTopPosition === null) {
        relatedProductsTopPosition = relatedProductsTop;
      }
      
      // User has scrolled past related products if we've recorded their position and current scroll is beyond it
      if (relatedProductsTopPosition !== null) {
        userScrolledPastRelatedProducts = scrollTop > relatedProductsTopPosition;
      }
    }
    
    // Add/remove 'test' class based on whether user scrolled past media
    if (userScrolledPastMedia) {
      productInfoBtnContainer.classList.add('test');
    } else {
      productInfoBtnContainer.classList.remove('test');
    }
    
    // Show sticky button only if:
    // 1. User scrolled past media AND
    // 2. Related products are not visible AND
    // 3. User hasn't scrolled past the related products section yet
    const shouldShowStickyButton = userScrolledPastMedia && 
                                  !relatedProductsVisible && 
                                  !userScrolledPastRelatedProducts;
    
    if (shouldShowStickyButton) {
      btnContainer.classList.add('fixed-at-bottom');
      btnContainer.parentElement.classList.add('fixed');
      if (outerAfterpay) outerAfterpay.classList.add('visible');
    } else {
      btnContainer.classList.remove('fixed-at-bottom');
      btnContainer.parentElement.classList.remove('fixed');    
      if (outerAfterpay) outerAfterpay.classList.remove('visible');
    }
  }
  
  // Throttle scroll events for better performance
  let ticking = false;
  function requestTick() {
    if (!ticking) {
      requestAnimationFrame(handleStickyButton);
      ticking = true;
      setTimeout(() => { ticking = false; }, 16); // ~60fps
    }
  }
  
  // Add event listeners
  window.addEventListener('scroll', requestTick);
  window.addEventListener('resize', () => {
    // Reset position tracking on resize
    relatedProductsTopPosition = null;
    handleStickyButton();
  });
  
  // Initial call
  handleStickyButton();
}
// Initialize sticky button functionality
initStickyButton();*/
/****** end of Sticky Button Implementation ******/ 

/****** Sticky Button Implementation ******/
// Simple Product Scroll Handler - Pure CSS Solution (Desktop Only)
function initProductScrollHandler() {
  const btnContainer = document.querySelector('.product__info-container .product-btn-container');
  const productReviews = document.querySelector('.product-reviews');
  const relatedProducts = document.querySelector('.custom_video');
 
  if (!btnContainer) return;
 
  let ticking = false;
 
  function handleScroll() {
    // Only run sticky logic on desktop screens
    if (window.innerWidth <= 768) {
      btnContainer.classList.remove('fixed-at-bottom', 'hiding');
      ticking = false;
      return;
    }

    const windowHeight = window.innerHeight;
   
    // Check if reviews section is visible
    const reviewsVisible = productReviews &&
      productReviews.getBoundingClientRect().top <= windowHeight;
   
    // Check if related products section is visible  
    const relatedVisible = relatedProducts &&
      relatedProducts.getBoundingClientRect().top <= windowHeight;
   
    // Update classes based on state - Pure CSS handles the animation
    if (relatedVisible) {
      btnContainer.classList.add('hiding');
      btnContainer.classList.remove('fixed-at-bottom');
    } else if (reviewsVisible) {
      btnContainer.classList.add('fixed-at-bottom');
      btnContainer.classList.remove('hiding');
    } else {
      btnContainer.classList.remove('fixed-at-bottom', 'hiding');
    }
   
    ticking = false;
  }
 
  function onScroll() {
    if (!ticking) {
      requestAnimationFrame(handleScroll);
      ticking = true;
    }
  }
 
  window.addEventListener('scroll', onScroll, { passive: true });
}

// Initialize
initProductScrollHandler();
/****** end of Sticky Button Implementation ******/
  
const productInfoBtnContainer = document.querySelector(".product__info-wrapper .product-btn-container");

if (window.innerWidth < 768) {
  // Fixed: Use vanilla JS style property instead of jQuery css()
  //productInfoBtnContainer.style.border = "2px solid red";
  productInfoBtnContainer.classList.add("sticky");
} else {
  productInfoBtnContainer.classList.remove("sticky");
}

/****** Single Page Scrollbar Controls Both Sides ******/
function initUnifiedScrollbar() {
  // Only run on desktop
  if (window.innerWidth < 750) return;

  const productContainer = document.querySelector('.product.grid');
  const leftSide = document.querySelector('.product__media-wrapper');
  const leftSideInner = document.querySelector('.product__media-wrapper-inner');
  const rightSide = document.querySelector('.product__info-wrapper');
  const body = document.body;

  if (!productContainer || !leftSide || !leftSideInner || !rightSide) return;

  let currentSide = null;
  let isOverProduct = false;
  let leftScrollHeight = 0;
  let scrollSpacer = null;

  // Create scroll spacer for left side
  function updateScrollSpacer() {
    if (!scrollSpacer) {
      scrollSpacer = document.createElement('div');
      scrollSpacer.className = 'scroll-spacer';
      productContainer.appendChild(scrollSpacer);
    }

    // Calculate the total height needed to scroll the left side
    leftScrollHeight = leftSideInner.scrollHeight;
    const viewportHeight = window.innerHeight;
    const spaceNeeded = leftScrollHeight - viewportHeight;
    
    if (spaceNeeded > 0) {
      scrollSpacer.style.height = `${spaceNeeded}px`;
    }
  }

  // Determine which side the cursor is on
  function updateCurrentSide(e) {
    const containerRect = productContainer.getBoundingClientRect();
    const mouseX = e.clientX - containerRect.left;
    const containerWidth = containerRect.width;
    const midPoint = containerWidth / 2;

    currentSide = mouseX < midPoint ? 'left' : 'right';
  }

  // Handle page scroll
  function handleScroll() {
    if (!isOverProduct || !currentSide) return;

    if (currentSide === 'left') {
      // Calculate scroll position for left side
      const pageScrollTop = window.pageYOffset || document.documentElement.scrollTop;
      const productTop = productContainer.offsetTop;
      const relativeScroll = pageScrollTop - productTop;
      
      if (relativeScroll >= 0 && relativeScroll <= leftScrollHeight) {
        // Sync left side scroll with page scroll
        leftSideInner.scrollTop = relativeScroll;
      }
    }
    
    // Check gradient for right side
    checkScrollableContent();
  }

  // Track cursor position
  function handleMouseMove(e) {
    updateCurrentSide(e);
  }

  // Handle mouse enter product container
  function handleMouseEnter(e) {
    isOverProduct = true;
    updateCurrentSide(e);
    updateScrollSpacer();
  }

  // Handle mouse leave product container
  function handleMouseLeave(e) {
    isOverProduct = false;
    currentSide = null;
  }

  // Check if right side content needs gradient
  function checkScrollableContent() {
    if (!rightSide) return;
    
    const windowHeight = window.innerHeight;
    const rightSideRect = rightSide.getBoundingClientRect();
    const rightSideBottom = rightSideRect.bottom;
    
    // Show gradient if there's more content below the viewport
    if (rightSideBottom > windowHeight + 50) {
      rightSide.classList.add('show-gradient');
    } else {
      rightSide.classList.remove('show-gradient');
    }
  }

  // Add event listeners
  productContainer.addEventListener('mouseenter', handleMouseEnter);
  productContainer.addEventListener('mouseleave', handleMouseLeave);
  productContainer.addEventListener('mousemove', handleMouseMove);
  window.addEventListener('scroll', handleScroll, { passive: true });

  // Check on load
  updateScrollSpacer();
  checkScrollableContent();

  // Watch for "Read More" expansion
  const toggleLink = document.querySelector('.toggle-description');
  if (toggleLink) {
    toggleLink.addEventListener('click', () => {
      setTimeout(() => {
        updateScrollSpacer();
        checkScrollableContent();
      }, 100);
    });
  }

  // Watch for accordion changes
  const accordions = document.querySelectorAll('.product__accordion.accordion details, .product__accordion_need_to_know');
  accordions.forEach(accordion => {
    const summary = accordion.tagName === 'DETAILS' ? 
      accordion.querySelector('summary') : 
      accordion.querySelector('#key_need_to_know');
    
    if (summary) {
      summary.addEventListener('click', () => {
        setTimeout(() => {
          updateScrollSpacer();
          checkScrollableContent();
        }, 600);
      });
    }
  });

  // Handle window resize
  let resizeTimeout;
  window.addEventListener('resize', () => {
    clearTimeout(resizeTimeout);
    resizeTimeout = setTimeout(() => {
      if (window.innerWidth < 750) {
        // Clean up on mobile
        if (scrollSpacer) {
          scrollSpacer.remove();
          scrollSpacer = null;
        }
        rightSide.classList.remove('show-gradient');
      } else {
        updateScrollSpacer();
        checkScrollableContent();
      }
    }, 250);
  });

  // Cleanup function
  return function cleanup() {
    productContainer.removeEventListener('mouseenter', handleMouseEnter);
    productContainer.removeEventListener('mouseleave', handleMouseLeave);
    productContainer.removeEventListener('mousemove', handleMouseMove);
    window.removeEventListener('scroll', handleScroll);
    if (scrollSpacer) {
      scrollSpacer.remove();
    }
  };
}

// Initialize unified scrollbar
let cleanupScrolling = initUnifiedScrollbar();

// Reinitialize on window resize if needed
window.addEventListener('resize', () => {
  if (window.innerWidth >= 750 && !cleanupScrolling) {
    cleanupScrolling = initUnifiedScrollbar();
  } else if (window.innerWidth < 750 && cleanupScrolling) {
    cleanupScrolling();
    cleanupScrolling = null;
  }
});
/****** End of Single Page Scrollbar ******/

});  /* end of  DOMContentLoaded */


// Function to set the height of .product__info-wrapper based on the first image
function setInfoWrapperHeight() {
  debugger;
  if (window.innerWidth > 768) {
    // Get the height of the first child of .product__media-list
    const firstImage = productMediaList.querySelector('li:first-child img');
    const firstImageHeight = firstImage.offsetHeight;
    if (firstImage) {
      //productInfoContainer.style.height = `${firstImage.clientHeight}px`;
      if (firstImageHeight > windowHeight) {
        productMediaContainer.style.height = `${sum}px`;
        productInfoContainer.style.height = `${sum}px`;
      }  
      else {
       
        productInfoContainer.style.height = `${firstImage.clientHeight}px`;
      }
    }
  } else {
    // Reset height when width is less than or equal to 768px
    //productInfoWrapper.style.height = '';
    productInfoContainer.style.height = '';
  }
}





document.addEventListener("scroll", function () {
    const container = document.querySelector(".product__info-container");
    if (window.scrollY > 0) {
        container.style.height = "calc(100vh - 29px)";
    } else {
        container.style.height = "calc(100vh - 70px)";
    }
});